import { Action } from '@ngrx/store';
import { ProcessQuestionModel } from '../models/questions.model';

export enum QuestionsActionTypes {
  LoadQuestions = '[Questions] Load Questions',
  UpdateQuestion = '[Questions] Update Question',
  RemoveQuestion = '[Questions] Remove Question',
  CleanState = '[Questions] Clean state',
}

export class LoadQuestions implements Action {
  readonly type = QuestionsActionTypes.LoadQuestions;

  constructor(
    public payload: {
      step_id: number;
      step_type: number;
      questions: ProcessQuestionModel[];
    }
  ) {}
}

export class UpdateQuestion implements Action {
  readonly type = QuestionsActionTypes.UpdateQuestion;

  constructor(
    public payload: {
      questionToUpdate: ProcessQuestionModel;
    }
  ) {}
}

export class RemoveQuestion implements Action {
  readonly type = QuestionsActionTypes.RemoveQuestion;

  constructor(
    public payload: {
      index: number;
    }
  ) {}
}

export class CleanQuestionsState implements Action {
  readonly type = QuestionsActionTypes.CleanState;
}

export type QuestionsActions =
  | LoadQuestions
  | UpdateQuestion
  | RemoveQuestion
  | CleanQuestionsState;
